/**
 * Routing Strategies — full CRUD over a subdomain's Owl "decisive" routing
 * strategies plus the zone-level data-feed switch. Subdomain-scoped via the
 * shared scope bar; the actual table + form live in `WafRoutingStrategiesPanel`.
 */
import { useState } from 'react';
import { Route } from 'lucide-react';
import { Container, PageHeader } from '@vnetwork/ui/layout';
import { EmptyState } from '@vnetwork/ui/data';
import { WafScopeBar, type WafScope } from './WafScopeBar';
import { WafRoutingStrategiesPanel } from './WafRoutingStrategiesPanel';
import styles from './WafAnalytics.module.css';

export function WafRoutingStrategies({ serviceId }: { serviceId: string }) {
  const [scope, setScope] = useState<WafScope>({});
  const domain = scope.subdomain;
  // A zone is selected but has no proxied subdomain → nothing to configure.
  const noSubdomain = !!scope.zone && !domain;

  return (
    <Container size="xl">
      <PageHeader
        icon={<Route size={22} />}
        title="Routing Strategies"
        description="Control how the selected subdomain's traffic is routed across CDN platforms."
      />

      <div className={styles.toolbar}>
        <WafScopeBar serviceId={serviceId} mode="subdomain" onChange={setScope} />
      </div>

      {noSubdomain ? (
        <EmptyState
          icon={<Route size={20} />}
          title="No proxied subdomains"
          description="This zone has no proxied subdomain. Proxy a record to manage its routing strategies."
        />
      ) : domain ? (
        <WafRoutingStrategiesPanel serviceId={serviceId} domain={domain} />
      ) : (
        <EmptyState
          icon={<Route size={20} />}
          title="Select a subdomain"
          description="Pick a subdomain above to manage its routing strategies."
        />
      )}
    </Container>
  );
}

export default WafRoutingStrategies;
